import { Actor, HttpAgent, type Identity } from '@icp-sdk/core/agent';
import { idlFactory, type _SERVICE as Backend } from '../bindings/backend/declarations/backend.did';
export type { QuoteV3 as Quote, FieldsV3 as Fields, Receipt, ProfileV3 as Profile, ProfileStatus, Milestone, Config as BillingConfig } from '../bindings/backend/declarations/backend.did';
import { HOST } from './api';
export type MiningStatus = Awaited<ReturnType<Backend['mining_status']>>;
export type MiningJob = MiningStatus['jobs'][number];
export type QuoteMining = Awaited<ReturnType<Backend['my_quote_mining']>>[number];
export type ScreenerStatus = Awaited<ReturnType<Backend['screener_reserve_status']>>;
export type ScreenerJob = ScreenerStatus['jobs'][number];
export type QuoteScreener = Awaited<ReturnType<Backend['my_quote_screener']>>[number];

export async function backend(identity?: Identity) {
  const id = import.meta.env.VITE_BACKEND_CANISTER_ID;
  if (!id) throw Error('Deploy the Soonscreener backend with dfx before saving favourites.');
  const local = import.meta.env.VITE_DFX_NETWORK === 'local';
  const agent = await HttpAgent.create({ host: local ? import.meta.env.VITE_DFX_HOST : HOST, identity });
  if (local) await agent.fetchRootKey();
  return Actor.createActor<Backend>(idlFactory, { agent, canisterId: id });
}
